'use strict';

import _, {get} from 'lodash';
import React, {PropTypes} from 'react';
import { connect } from 'react-redux';

import { monthYear } from '../../../lib/prettyDate';

@connect((state, props) => {
  const licenses = _(state.licenses)
                    .map(license => license)
                    .orderBy(['stateName', 'licenseName'])
                    .value();
  return {
    licenses,
    script: props.script,
    labels: get(state, 'labels.LicensesSummary', {})
  };
})
export default class LicensesSummary extends React.Component {
  static propTypes = {
    licenses: PropTypes.array,
    script: PropTypes.bool,
    labels: PropTypes.object
  }

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className='expanded-accordion-content licenses-summary'>
        <div className='callout'>{this.props.labels.callout}</div>
        {
          this.props.script
          &&
            <div className='speaking-callout'>
            {this.props.labels.speakingCallout}
            </div>
        }
        <div className='summary-container'>
          <ul>
            <li className='summary-row'>
              <div className='summary-row-item'>License</div>
              <div className='summary-row-item'>State</div>
              <div className='summary-row-item'>Renewal Date</div>
            </li>
            {
              _.map(this.props.licenses, item =>
                <li className='summary-row'>
                  <div className='summary-row-item'>{item.licenseName}</div>
                  <div className='summary-row-item'>{item.stateName}</div>
                  <div className='summary-row-item'>{_.isNil(item.renewalDate) ? '' : monthYear(item.renewalDate)}</div>
                </li>
              )
            }
            {
              (this.props.licenses.length === 0 && (this.props.profile.licenseStatus == 1 || !this.props.profile.licenseStatus))
              &&
              <li className='summary-row'>
                <div className='summary-row-item-empty'>No licenses have been selected</div>
              </li>
            }
            {
              this.props.profile.licenseStatus == 2
              &&
              <li className='summary-row'>
                <div className='summary-row-item-empty'>License has lapsed{this.props.profile.willingToReinstateLicense ? ' and willing to renew' : ''}</div>
              </li>
            }
            {
              this.props.profile.licenseStatus == 3
              &&
              <li className='summary-row'>
                <div className='summary-row-item-empty'>Never been licensed</div>
              </li>
            }
          </ul>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./shared/react/applicant/LicensesSummary/index.js